var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { filterWeeks, getNeededColumnsForHistoryV2 } from '../d3-services/data-with-history.functions';
import { GraphControllerV2 } from './graph-v2';
var SectionHeader = /** @class */ (function (_super) {
    __extends(SectionHeader, _super);
    function SectionHeader(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        return _this;
    }
    SectionHeader.prototype.pre = function () {
    };
    SectionHeader.prototype.init = function () {
        _super.prototype._init.call(this);
        this.element.style.height = "3rem";
        this.element.style.alignItems = "flex-start";
        this.element.style.margin = "0";
        // let h = document.createElement('h3');
        // h.innerText = this.mapping.parameters[0][0].label;
        // h.style.fontFamily = 'Replica';
        // h.style.textAlign = 'left';
        // h.style.fontSize = '1rem';
        // h.style.lineHeight = '1.44';
        // h.style.margin = '0';
        // this.element.appendChild(h);
    };
    SectionHeader.prototype.prepareData = function (data) {
        var neededColumns = getNeededColumnsForHistoryV2(data, this.mapping);
        var history = filterWeeks(data, neededColumns);
        this.main.dataStore.setGraph(this.mapping.slug, history);
        return {
            "history": history,
            "latest": data[0],
            "slice": history.slice(0, 8),
        };
    };
    SectionHeader.prototype.redraw = function (data) {
        _super.prototype.redraw.call(this, data);
    };
    SectionHeader.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return SectionHeader;
}(GraphControllerV2));
export default SectionHeader;
